.bannerMargins {
  margin-left: 16px;
  margin-right: 16px;
}

@media all and (--reefer-media-tablet-min) {
  .bannerMargins {
    margin-left: 64px;
    margin-right: 64px;
  }
}
